import { render, staticRenderFns } from "./UiGrids.vue?vue&type=template&id=5fcf880e&"
import script from "./UiGrids.vue?vue&type=script&lang=js&"
export * from "./UiGrids.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports